import React from "react";
import useMovement from "../hooks/useMovement";

const MovementControls = ({ currentMode, colors, isRtl }) => {
  const movement = useMovement({ currentMode });
  
  // Helper to trigger keyboard events programmatically
  const triggerKey = (key, type = "keydown") => {
    const event = new KeyboardEvent(type, { key });
    window.dispatchEvent(event);
  };

  // Styles for round controller
  const size = 120; // Increased width for controller
  const btnSize = 40;
  const center = size / 2 - btnSize / 2;
  // Adjusted positions for larger Shift button
  const shiftBtnWidth = btnSize * 1.5;
  const shiftBtnLeft = (size - shiftBtnWidth) / 2;
  const positions = {
    up: { top: 0, left: center },
    down: { bottom: 0, left: center },
    left: { left: 0, top: center },
    right: { right: 0, top: center },
    shift: { left: shiftBtnLeft, top: center },
  };

  // ArrowButton component for reusability
  const ArrowButton = ({ direction, onDown, onUp, style, active }) => {
    // direction: 'up', 'down', 'left', 'right'
    let caret = '^';
    let rotate = 0;
    if (direction === 'down') rotate = 180;
    if (direction === 'left') rotate = -90;
    if (direction === 'right') rotate = 90;
    return (
      <button
        onMouseDown={onDown}
        onMouseUp={onUp}
        onMouseLeave={onUp} // Stop movement if mouse leaves button
        onTouchStart={onDown}
        onTouchEnd={onUp}
        onTouchCancel={() => console.log("alksjdlaksjdlkajsd")} // Stop movement if touch is canceled (finger leaves button)
        style={{
          ...style,
          border: 'none',
          background: 'transparent',
          color: active ? (colors?.primary || '#fff') : '#fff',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          borderRadius: '50%',
          width: 40,
          height: 40,
          cursor: 'pointer',
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ transform: `rotate(${rotate}deg)`, display: 'inline-block', color: active ? (colors?.primary || '#fff') : '#fff' }}>{caret}</span>
      </button>
    );
  };
  const positionStyle = {
    left: isRtl ? "3rem" : "auto",
    right: isRtl ? "0rem" : "3rem",
  }
  return (
    <div className="movementControls"
      style={{
        position: "fixed",
        width: size,
        ...positionStyle,
      }}>
      <div
      className="buttonsWrapper"
        style={{
          position: "relative",
          width: size,
          height: size,
          borderRadius: "50%",
          background: "rgba(122, 112, 112, 0.69)",
          boxShadow: "0 0 8px #aaa",
          margin: "2rem auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Up */}
        <ArrowButton
          direction="up"
          onDown={() => triggerKey("ArrowUp", "keydown")}
          onUp={() => triggerKey("ArrowUp", "keyup")}
          // onTouchStart={() => triggerKey("ArrowUp", "keydown")}
          // onTouchEnd={() => triggerKey("ArrowUp", "keyup")}
          
          style={{ ...positions.up }}
          active={movement.moveForward || movement.lookUp}
        />
        {/* Down */}
        <ArrowButton
          direction="down"
          onDown={() => triggerKey("ArrowDown", "keydown")}
          onUp={() => triggerKey("ArrowDown", "keyup")}
          // onTouchStart={() => triggerKey("ArrowDown", "keydown")}
          // onTouchEnd={() => triggerKey("ArrowDown", "keyup")}
          style={{ ...positions.down }}
          active={movement.moveBackward || movement.lookDown}
        />
        {/* Left */}
        <ArrowButton
          direction="left"
          onDown={() => triggerKey("ArrowLeft", "keydown")}
          onUp={() => triggerKey("ArrowLeft", "keyup")}
          style={{ ...positions.left }}
          active={movement.moveLeft || movement.lookLeft}
        />
        {/* Right */}
        <ArrowButton
          direction="right"
          onDown={() => triggerKey("ArrowRight", "keydown")}
          onUp={() => triggerKey("ArrowRight", "keyup")}
          style={{ ...positions.right }}
          active={movement.moveRight || movement.lookRight}
        />
        {/* Shift (center) */}
        <button
          onMouseDown={() => triggerKey("Shift", "keydown")}
          onMouseUp={() => triggerKey("Shift", "keyup")}
          style={{
            position: "absolute",
            ...positions.shift,
            width: shiftBtnWidth,
            height: btnSize,
            borderRadius: btnSize, // pill shape
            background: "transparent",
            border: `1px solid ${movement.shiftPressed ? (colors?.primary || '#fff') : 'rgba(255, 255, 255, 0.5)'}`,
            fontWeight: "normal",
            fontSize: "0.85rem",
            letterSpacing: "0.02em",
            color: movement.shiftPressed ? (colors?.primary || '#fff') : '#fff',
            cursor: "pointer",
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s",
          }}
        >
          Shift
        </button>
      </div>
    </div>
  );
};

export default MovementControls;